export const ROLE_ID = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  EMPLOYEE: 3,
} as const;

export type RoleId = (typeof ROLE_ID)[keyof typeof ROLE_ID];
